import React from "react";
import loadable from "@loadable/component";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";
import { appUrl } from "../../../constants/url-constants";
import RtoVehInfoBanner from "../rto-veh-info-banner";
import RtoVehInfoContent from "../rto-veh-info-content";
import RtoInfoBlogs from "../rto-veh-info-blogs";
import PilotFaqV2 from "../pilot-faq-v2";
import RtoVehInfoListItems from "../../shared/rto-veh-info-list-items";
import RtoVehInfoPopularCities from "../../shared/rto-veh-info-popular-cities";
import RtoVehInfoBreadcrumbs from "../../shared/rto-veh-info-breadcrumbs";
import RtoVehInfoRtoList from "../../shared/rto-veh-info-rto-list";
import RtoVehInfoServiceList from "../rto-veh-info-service-list";
import RtoVehInfoVehSellingDetails from "../rto-veh-info-veh-selling-details";

import styles from "./styles.css";
import AdsComponent from "../../shared/ads";
import { OGImage, OG_IMAGE_TYPES } from "../../shared/og-image";
import useC2bCleverTap from "../../../hooks/use-c2b-clevertap";

const RtoVehInfoQuestionContainer = loadable(() => import("../rto-veh-info-question-container"));
const RtoVehInfoBannerList = loadable(() => import("../rto-veh-info-banner-list"));

const RtoVehInfo = ({
    cms,
    faqList,
    stateList,
    history,
    statsigDynamicConfigData,
    websiteAdvertisementBannerData
}) => {
    useC2bCleverTap("RTO_check");
    const canonical = ((history.location.pathname || "").toLowerCase()).replace(/\/$/, "");
    const {  websiteAds = {}} = statsigDynamicConfigData || {};

    return (
        <div>
            <Helmet>
                <title>{cms.meta.title}</title>
                <meta name="description" content={cms.meta.description} />
                <link href={`${appUrl()}${canonical}/`} rel="canonical" />
                <meta name="ROBOTS" content="INDEX,FOLLOW" />
            </Helmet>
            <OGImage type={OG_IMAGE_TYPES.rto} />
            <RtoVehInfoBanner canonical={canonical}/>
            {/* { websiteAdvertisementBannerData && <div styleName={"styles.adsBanner"}><GenericBrandBanner config={websiteAds} type={"970x90"} fetchpriority="high" pageType="rto-info"  position = "top" source = "webApp"/></div>} */}
            <div styleName="styles.adsContainerInPage">
                <AdsComponent
                    platformType="DESKTOP"
                    url={`${appUrl()}/rto-vehicle-registration-details/`}
                    slotName= "cars24_rto_desktop_leaderboard_970x90"
                    bu = "rto"
                    width={970}
                    height={90}
                />
            </div>
            <div styleName={"styles.wrapper"}>
                <RtoVehInfoContent />
                <RtoVehInfoServiceList />
                <RtoVehInfoQuestionContainer />
                <div styleName="styles.adsContainerInPage styles.fuelBottomAds">
                    <AdsComponent
                        platformType="DESKTOP"
                        url={`${appUrl()}/rto-vehicle-registration-details/`}
                        slotName= "cars24_rto_desktop_below_quiz_970x90"
                        bu = "rto"
                        width={970}
                        height={90}
                    />
                </div>
                <RtoVehInfoVehSellingDetails />
                <RtoVehInfoRtoList isDesktop={true}/>
                <RtoVehInfoListItems
                    isDesktop={true}
                    list={stateList}
                    title={"RTO in different States of India"}
                    openText={"View more states"}
                    closedText={"View less states"}
                />
                <RtoVehInfoBannerList />
                <RtoVehInfoPopularCities isDesktop={true} websiteAdvertisementBannerData={websiteAdvertisementBannerData} websiteAds={websiteAds}/>
                <RtoInfoBlogs />
                <div styleName={"styles.faqWrapper"}>
                    <PilotFaqV2 list={faqList}/>
                </div>
                <div styleName={"styles.rtoVehInfoBreadcrumbs"}>
                    <RtoVehInfoBreadcrumbs />
                </div>

            </div>
        </div>
    );
};

RtoVehInfo.propTypes = {
    cms: PropTypes.object,
    faqList: PropTypes.array,
    stateList: PropTypes.array,
    history: PropTypes.object,
    statsigDynamicConfigData: PropTypes.object,
    websiteAdvertisementBannerData: PropTypes.bool,
    fetchAdsDetailsConnect: PropTypes.func
};

export default RtoVehInfo;
